import { useHandleSignInCallback } from '@logto/react';
import { useNavigate } from 'react-router-dom';

const POST_LOGIN_KEY = 'morabi.postLoginPath';

export function Callback() {
  const navigate = useNavigate();
  const { isLoading } = useHandleSignInCallback(() => {
    let target = '/';
    try {
      target = sessionStorage.getItem(POST_LOGIN_KEY) || '/';
      sessionStorage.removeItem(POST_LOGIN_KEY);
    } catch {
      // no sessionStorage — fall back to the home page
    }
    navigate(target, { replace: true });
  });
  return <div className="auth-gate">{isLoading ? 'A iniciar sessão…' : 'A redirecionar…'}</div>;
}
